import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Listing state
  fabrics: [],
  total: 0,
  page: 1,
  size: 25,
  search: '',
  filterType: 'ALL', // 'ALL' | 'PUBLIC' | 'PRIVATE'
  fabricCategories: [],

  // Metrics
  metrics: {
    user_email: 'username@organization.com',
    user_name: '',
    fabric_count: '0',
    thread_count: '0',
    team_count: '0',
  },

  // View state
  showForm: false,
  editingFabric: null,
  fabricDetails: null,
};

const dataFabricSlice = createSlice({
  name: 'dataFabric',
  initialState,
  reducers: {

    // ── Listing ────────────────────────────────────────────
    setFabrics(state, action) {
      state.fabrics = action.payload;
    },

    setTotal(state, action) {
      state.total = action.payload;
    },

    setPage(state, action) {
      state.page = action.payload;
    },

    setSize(state, action) {
      state.size = action.payload;
    },

    setSearch(state, action) {
      state.search = action.payload;
    },

    setFilterType(state, action) {
      state.filterType = action.payload;
    },

    setFabricCategories(state, action) {
      state.fabricCategories = action.payload;
    },

    // ── Metrics ────────────────────────────────────────────
    setMetrics(state, action) {
      state.metrics = action.payload;
    },

    // ── View ───────────────────────────────────────────────
    setShowForm(state, action) {
      state.showForm = action.payload;
    },

    setEditingFabric(state, action) {
      state.editingFabric = action.payload;
    },

    setFabricDetails(state, action) {
      state.fabricDetails = action.payload;
    },

    // ── Bulk: open edit form ───────────────────────────────
    loadEditingFabric(state, action) {
      state.editingFabric = action.payload;
      state.showForm = true;
      state.fabricDetails = null;
    },

    // ── Open fabric details ────────────────────────────────
    openFabricDetails(state) {
      state.showForm = false;
      state.editingFabric = null;
      // fabricDetails set after API call
    },

    // ── Reset form ─────────────────────────────────────────
    resetForm(state) {
      state.showForm = false;
      state.editingFabric = null;
    },

    // ── Full reset ─────────────────────────────────────────
    resetDataFabricState() {
      return initialState;
    },
  },
});

export const {
  setFabrics,
  setTotal,
  setPage,
  setSize,
  setSearch,
  setFilterType,
  setFabricCategories,
  setMetrics,
  setShowForm,
  setEditingFabric,
  setFabricDetails,
  loadEditingFabric,
  openFabricDetails,
  resetForm,
  resetDataFabricState,
} = dataFabricSlice.actions;

export default dataFabricSlice.reducer;